'use client';
import { useGSAP } from '@gsap/react';
import { Box, Grid, Stack, Text, VStack } from '@chakra-ui/react';

import BlockDiagonalDivider from 'shared/BlockDiagonalDivider';
import { conditionsAnimation } from 'shared/gsap';
import BlockShadow from 'shared/BlockShadow';
import InterText from 'shared/InterText';
import NextImage from 'shared/NextImage';

import { SECTIONS_IDS } from 'constants/global';
import { textsData } from 'constants/conditions';
import Bg from 'assets/illustrations/conditionsBg.webp';

const Conditions = () => {
  useGSAP(conditionsAnimation);

  return (
    <Box
      as="section"
      id={SECTIONS_IDS.conditions}
      w="full"
      h={{ mobile: '570px', tablet: 'clamp(572px, 65vw, 650px)', laptop: '860px' }}
      alignItems="start"
      pos="relative"
      overflow="hidden"
      p={{ mobile: '64px 16px 0', tablet: '90px 40px 0', laptop: '127px 40px 0' }}
    >
      <BlockDiagonalDivider position="top" direction="right" zIndex="2" />

      <Box
        w="full"
        minW={{ mobile: '600px', tablet: 'unset' }}
        bottom="0"
        left={{ mobile: 'calc(50% - (600px / 2))', tablet: '0' }}
        pos="absolute"
        zIndex="1"
      >
        <NextImage src={Bg} alt="Фоновое изображение" w="full" h="full" />
      </Box>

      <VStack
        w="full"
        gap={{ mobile: '48px', tablet: '32px', laptop: '56px' }}
        pos="relative"
        zIndex="3"
      >
        <Text as="h2" textTransform="uppercase" textAlign="center">
          Что даёт Траектория лидерства?
        </Text>

        <Grid w="full" templateColumns="1fr" templateRows="1fr" justifyItems="center">
          {textsData.map(({ title, text }, i) => (
            <Stack
              key={`${SECTIONS_IDS.conditions}-text-block-${i + 1}`}
              id={`${SECTIONS_IDS.conditions}-text-block-${i + 1}`}
              direction={{ mobile: 'column', xxl: 'row' }}
              maxW={{ tablet: '455px', laptop: '660px', xxl: '1170px' }}
              minH={{ xxl: '100px' }}
              align="center"
              gap={{ mobile: '10px', xxl: '50px' }}
              gridArea="1 / 1"
              opacity={i === 0 ? '1' : '0'}
              zIndex={i * -1}
            >
              <Text
                as="h3"
                textStyle="h4"
                flex={{ xxl: '1' }}
                w="full"
                textAlign={{ mobile: 'center', xxl: 'end' }}
              >
                {title}
              </Text>

              <InterText
                flex={{ xxl: '1' }}
                textStyle="b3"
                textAlign={{ mobile: 'center', xxl: 'start' }}
              >
                {text}
              </InterText>
            </Stack>
          ))}
        </Grid>
      </VStack>

      <BlockShadow
        position="bottom"
        h={{ mobile: '100px', tablet: '105px', laptop: '318px' }}
        zIndex="2"
      />
    </Box>
  );
};

export default Conditions;
